import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Cancel() {
  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="cancel-page">
      <div className="max-w-xl">
        <p className="overline mb-6">No payment was taken</p>
        <h1 className="font-serif-display text-6xl md:text-7xl font-light leading-none tracking-tighter mb-8">
          The curtain stays <span className="italic text-[var(--mm-text-dim)]">drawn</span>.
        </h1>
        <p className="text-[var(--mm-text-dim)] mb-10 font-light">
          You closed the checkout before completing it. Metamorph is still here when you&apos;re ready.
        </p>
        <Link to="/" className="btn-line" data-testid="cancel-back">
          <ArrowLeft className="w-4 h-4" strokeWidth={1} /> Return
        </Link>
      </div>
    </main>
  );
}
